/**
 * Allow-list of admin emails gated to migration / dual-render tooling.
 *
 * Extracted from the router so leaf components (e.g. CreatePdf.vue's
 * "Wersja serwerowa (NEW)" buttons) can import it without pulling in the whole
 * router module. The router re-exports this for backward compatibility.
 */
export const MIGRATION_ALLOWED_EMAILS = ['kamildudek6@gmail.com'];
